// extracted by mini-css-extract-plugin
export var numpadContainer = "_ks-1";
export var phoneButton = "_ks-0";